<template>
  <v-card>
    <v-card-title class="headline black--text" :style="backgroundStarStyle">
      <span>Beta developments</span>
      <v-spacer></v-spacer>
      <v-btn icon light small class="m-0" @click="closeBetaDevelopments()">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card class="mx-2">
      <v-container
        fluid
        grid-list-lg
        class="px-3"
        :style="'max-height: ' + cardHeight + 'px; overflow-y: scroll'"
      >
        <v-col
          cols="12"
          v-for="(betaDevelopment, index) in betaDevelopmentsList"
          :key="index"
          @click="betaDevelopmentClicked(index)"
        >
          <v-hover>
            <v-card
              :color="cardBackground()"
              slot-scope="{ hover }"
              :class="`elevation-${hover ? 10 : 2}`"
            >
              <v-col cols="11">
                <h3>{{ betaDevelopment }}</h3>
              </v-col>
              <v-divider light></v-divider>
            </v-card>
          </v-hover>
        </v-col>
      </v-container>
    </v-card>
  </v-card>
</template>

<script>
export default {
  name: 'betaDevelopmentDashboard',

  data() {
    return {
      betaDevelopmentsList: [
        'Earth-Moon Trajectories'
      ],
      cardHeight: 600
    }
  },

  computed: {
    backgroundStarStyle() {
      return (
        'background: #3BE287'
      )
    }
  },

  methods: {

    cardBackground() {
      if (this.$vuetify.theme.dark === false) {
        return 'grey lighten-4'
      } else {
        return ''
      }
    },

    closeBetaDevelopments() {
      this.$emit('betaDevelopmentsClosed')
    },

    betaDevelopmentClicked(betaDevelopmentIndex) {
      this.$emit('betaDevelopmentsClosed')
      switch (betaDevelopmentIndex) {
        case 0:
          this.$router.push('/earthMoonTrajectoryRequest')
          break
      }
    }
  }
}
</script>
